import Timeslot, { Conflict, PatchTimeslotPayload, PostTimeSlotPayload } from "app/models/timeslot"
import Request, { RequestUpdateBody } from "app/models/request"
import { Params } from "./planningTimeslots.reducer"

export enum Types {
  DELETE = "PLANNING_TIMESLOTS_DELETE",
  DELETE_SUCCESS = "PLANNING_TIMESLOTS_DELETE_SUCCESS",
  DELETE_FAIL = "PLANNING_TIMESLOTS_DELETE_FAIL",
  POST = "PLANNING_TIMESLOTS_POST",
  POST_SUCCESS = "PLANNING_TIMESLOTS_POST_SUCCESS",
  POST_FAIL = "PLANNING_TIMESLOTS_POST_FAIL",
  POST_TIMESLOT_EMPLOYEE_REQUEST = "PLANNING_TIMESLOTS_POST_EMPLOYEE_REQUEST",
  POST_TIMESLOT_EMPLOYEE_REQUEST_SUCCESS = "PLANNING_TIMESLOTS_POST_EMPLOYEE_REQUEST_SUCCESS",
  POST_TIMESLOT_EMPLOYEE_REQUEST_FAIL = "PLANNING_TIMESLOTS_POST_EMPLOYEE_REQUEST_FAIL",
  PATCH_TIMESLOT_EMPLOYEE_REQUEST = "PLANNING_TIMESLOTS_PATCH_EMPLOYEE_REQUEST",
  PATCH_TIMESLOT_EMPLOYEE_REQUEST_SUCCESS = "PLANNING_TIMESLOTS_PATCH_EMPLOYEE_REQUEST_SUCCESS",
  PATCH_TIMESLOT_EMPLOYEE_REQUEST_FAIL = "PLANNING_TIMESLOTS_PATCH_EMPLOYEE_REQUEST_FAIL",
  PATCH = "PLANNING_TIMESLOTS_PATCH",
  PATCH_CONFLICT = "PLANNING_TIMESLOTS_PATCH_CONFLICT",
  PATCH_SUCCESS = "PLANNING_TIMESLOTS_PATCH_SUCCESS",
  PATCH_FAIL = "PLANNING_TIMESLOTS_PATCH_FAIL",
  GET = "PLANNING_TIMESLOTS_GET",
  GET_SUCCESS = "PLANNING_TIMESLOTS_GET_SUCCESS",
  GET_FAIL = "PLANNING_TIMESLOTS_GET_FAIL",
  HIGHLIGHT_USER = "HIGHLIGHT_USER",
  SELECT_TIMESLOT_SET = "SELECT_TIMESLOT_SET",
  SELECT_TIMESLOT_RESET = "SELECT_TIMESLOT_RESET",
}

export type Action =
  | DeleteTimeslotsAction
  | DeleteTimeslotsSuccessAction
  | DeleteTimeslotsFailAction
  | PostTimeslotsAction
  | PostTimeslotsSuccessAction
  | PostTimeslotsFailAction
  | PostTimeslotsEmployeeRequestsAction
  | PostTimeslotsEmployeeRequestsSuccessAction
  | PostTimeslotsEmployeeRequestsFailAction
  | PatchTimeslotsEmployeeRequestsAction
  | PatchTimeslotsEmployeeRequestsSuccessAction
  | PatchTimeslotsEmployeeRequestsFailAction
  | PatchTimeslotsAction
  | PatchTimeslotsSuccessAction
  | PatchTimeslotConflictSuccess
  | PatchTimeslotsFailAction
  | GetTimeslotsAction
  | GetTimeslotsSuccessAction
  | GetTimeslotsFailAction
  | HighlightUserAction
  | SelectTimeslotAction
  | SelectTimeslotResetAction

export type PostTimeslotsAction = {
  payload: { data: PostTimeSlotPayload }
  type: Types.POST
}

export type PostTimeslotsSuccessAction = {
  payload: { data: Timeslot }
  type: Types.POST_SUCCESS
}

export type PostTimeslotsFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export type PostTimeslotsEmployeeRequestsAction = {
  payload: { data: Request }
  type: Types.POST_TIMESLOT_EMPLOYEE_REQUEST
}

export type PostTimeslotsEmployeeRequestsSuccessAction = {
  type: Types.POST_TIMESLOT_EMPLOYEE_REQUEST_SUCCESS
}

export type PostTimeslotsEmployeeRequestsFailAction = {
  payload: { errors: object }
  type: Types.POST_TIMESLOT_EMPLOYEE_REQUEST_FAIL
}

export type PatchTimeslotsAction = {
  payload: { data: PatchTimeslotPayload; id: number }
  type: Types.PATCH
}

export type PatchTimeslotsEmployeeRequestsAction = {
  payload: { data: RequestUpdateBody }
  type: Types.PATCH_TIMESLOT_EMPLOYEE_REQUEST
}

export type PatchTimeslotsEmployeeRequestsSuccessAction = {
  type: Types.PATCH_TIMESLOT_EMPLOYEE_REQUEST_SUCCESS
}

export type PatchTimeslotsEmployeeRequestsFailAction = {
  payload: { errors: object }
  type: Types.PATCH_TIMESLOT_EMPLOYEE_REQUEST_FAIL
}

export type PatchTimeslotsSuccessAction = {
  type: Types.PATCH_SUCCESS
}

export type PatchTimeslotConflictSuccess = {
  type: Types.PATCH_CONFLICT
  payload: { data: Conflict; timeslotId: number }
}

export type PatchTimeslotsFailAction = {
  payload: { errors: object }
  type: Types.PATCH_FAIL
}

export type DeleteTimeslotsAction = {
  payload: { id: number }
  type: Types.DELETE
}

export type DeleteTimeslotsSuccessAction = {
  payload: { data: Timeslot }
  type: Types.DELETE_SUCCESS
}

export type DeleteTimeslotsFailAction = {
  payload: { errors: object }
  type: Types.DELETE_FAIL
}

export type GetTimeslotsAction = {
  payload: { params: Params }
  type: Types.GET
}

export type GetTimeslotsSuccessAction = {
  type: Types.GET_SUCCESS
  payload: { data: Timeslot[] | undefined }
}

export type GetTimeslotsFailAction = {
  type: Types.GET_FAIL
  payload: { errors: object }
}

export type HighlightUserAction = {
  type: Types.HIGHLIGHT_USER
  payload: { id: string }
}

export type SelectTimeslotAction = {
  type: Types.SELECT_TIMESLOT_SET
  payload: { timeslotId: number }
}

export type SelectTimeslotResetAction = {
  type: Types.SELECT_TIMESLOT_RESET
}

export function deleteTimeslots(id: number): DeleteTimeslotsAction {
  return {
    payload: { id },
    type: Types.DELETE,
  }
}

export function deleteTimeslotsSuccess(data: Timeslot): DeleteTimeslotsSuccessAction {
  return {
    payload: { data },
    type: Types.DELETE_SUCCESS,
  }
}

export function deleteTimeslotsFail(errors: object): DeleteTimeslotsFailAction {
  return {
    payload: { errors },
    type: Types.DELETE_FAIL,
  }
}

export function postTimeslots(data: PostTimeSlotPayload): PostTimeslotsAction {
  return {
    payload: { data },
    type: Types.POST,
  }
}

export function postTimeslotsSuccess(data: Timeslot): PostTimeslotsSuccessAction {
  return {
    payload: { data },
    type: Types.POST_SUCCESS,
  }
}

export function postTimeslotsFail(errors: object): PostTimeslotsFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}

export function postTimeslotsEmployeeRequests(data: Request): PostTimeslotsEmployeeRequestsAction {
  return {
    payload: { data },
    type: Types.POST_TIMESLOT_EMPLOYEE_REQUEST,
  }
}

export function postTimeslotsEmployeeRequestsSuccess(): PostTimeslotsEmployeeRequestsSuccessAction {
  return {
    type: Types.POST_TIMESLOT_EMPLOYEE_REQUEST_SUCCESS,
  }
}

export function postTimeslotsEmployeeRequestsFail(errors: object): PostTimeslotsEmployeeRequestsFailAction {
  return {
    payload: { errors },
    type: Types.POST_TIMESLOT_EMPLOYEE_REQUEST_FAIL,
  }
}

export function patchTimeslotsEmployeeRequests(data: RequestUpdateBody): PatchTimeslotsEmployeeRequestsAction {
  return {
    payload: { data },
    type: Types.PATCH_TIMESLOT_EMPLOYEE_REQUEST,
  }
}

export function patchTimeslotsEmployeeRequestsSuccess(): PatchTimeslotsEmployeeRequestsSuccessAction {
  return {
    type: Types.PATCH_TIMESLOT_EMPLOYEE_REQUEST_SUCCESS,
  }
}

export function patchTimeslotsEmployeeRequestsFail(errors: object): PatchTimeslotsEmployeeRequestsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_TIMESLOT_EMPLOYEE_REQUEST_FAIL,
  }
}

export function patchTimeslots(id: number, data: PatchTimeslotPayload): PatchTimeslotsAction {
  return {
    payload: { data, id },
    type: Types.PATCH,
  }
}

export function patchTimeslotsSuccess(): PatchTimeslotsSuccessAction {
  return {
    type: Types.PATCH_SUCCESS,
  }
}

export function patchTimeslotConflictSuccess(timeslotId: number, data: Conflict): PatchTimeslotConflictSuccess {
  return {
    payload: { data, timeslotId },
    type: Types.PATCH_CONFLICT,
  }
}
export function patchTimeslotsFail(errors: object): PatchTimeslotsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}

export function getPlanningTimeslots(params: Params): GetTimeslotsAction {
  return {
    payload: { params },
    type: Types.GET,
  }
}

export function getPlanningTimeslotsSuccess(data: Timeslot[] | undefined): GetTimeslotsSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}
export function getPlanningTimeslotsFail(errors: object): GetTimeslotsFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function highlightUser(id: string): HighlightUserAction {
  return {
    payload: { id },
    type: Types.HIGHLIGHT_USER,
  }
}

export function selectTimeslot(timeslotId: any): SelectTimeslotAction {
  return {
    payload: { timeslotId },
    type: Types.SELECT_TIMESLOT_SET,
  }
}

export function selectTimeslotReset(): SelectTimeslotResetAction {
  return {
    type: Types.SELECT_TIMESLOT_RESET,
  }
}
